
const BASE_API = "https://spacesheepbackend2-h4hpffhkccemhrhn.canadacentral-01.azurewebsites.net/"

export type Highscore = {
  name: string;
  level: number;
  n: string;      // bigint jako string
  date?: string;  // opcjonalnie, jeśli zwracasz datę z backendu
};

export async function saveScoreApi({ name, level, N }: { name: string; level: number; N: bigint }): Promise<void> {
  await fetch(`${BASE_API}api/highscores`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name,
      level,
      n: N.toString()
    }),
  });
}

// Pobieranie leaderboardu (GET)
export async function getHighscores(): Promise<Highscore[]> {
  const res = await fetch(`${BASE_API}api/highscores/top?limit=10`);
  if (!res.ok) throw new Error("Błąd pobierania wyników");
  return await res.json() as Highscore[];
}


